import { Button, Divider, Menu, Spin, Table } from 'antd';
import { ColumnsType, TableRowSelection } from 'antd/lib/table/interface';
import { useEffect, useState } from 'react';
import SearchTable from '../../Shared/Table/searchTable';
import { useHistory } from 'react-router-dom';
import returnDisposalService from '../Service/returnDisposal';
import type { MenuProps } from 'antd';
import { useActions } from '@root/core/hooks/useActions';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';

interface DataType {
  key: React.Key;
  No: number;
  sellerName: string;
  productName: string;
  SKU: string;
  quantity: number;
  processType: string;
  status: string;
  updateDate: string;
  returnType: string;
}
interface labelSelect {
  key: string;
  label: string;
}

// handle get List returns

function TableReturn() {
  const [searchBy, setSearchBy] = useState<string>('');
  const [filterDateFrom, setFilterDateFrom] = useState<string>();
  const [filterDateTo, setFilterDateTo] = useState<string>();
  const [filterBy, setFilterBy] = useState<string>();
  const [valueSearch, setValueSearch] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [sort, setSort] = useState(true);
  const debounce = useDebounce(valueSearch, 1000);

  const history = useHistory();
  const { handleReturnDisposalListWithPagination } = useActions();

  const columns: ColumnsType<DataType> = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: 'Seller Name',
      dataIndex: 'name'
    },
    {
      title: 'Product Name',
      dataIndex: 'productName'
    },
    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    {
      title: 'Product Type',
      dataIndex: 'quantity'
    },
    {
      title: 'Retransfer / Disposal',
      dataIndex: 'processType',
      render: (text: string) => <div>{text == 'return' ? 'retransfer' : text}</div>
    },
    {
      title: 'Status',
      dataIndex: 'returnStatus'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Update Date
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(true);
                setCurrentPage(1);
              }}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
                setCurrentPage(1);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt'
    }
  ];

  useEffect(() => {
    if (currentPage === 1) {
      handleReturnDisposalListWithPagination(
        currentPage,
        sort,
        filterDateFrom,
        filterDateTo,
        filterBy,
        searchBy,
        debounce
      );
    } else {
      setCurrentPage(1);
    }
  }, [sort, filterDateFrom, filterDateTo, filterBy, searchBy, debounce]);

  const { data, loading } = useTypedSelector(
    (state) => state.returnDisposalReducer
  );

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [labelFilter, setLabelFilter] = useState<labelSelect>({
    key: '1',
    label: 'Select'
  });
  const [labelReturn, setLabelReturn] = useState<labelSelect>({
    key: '1',
    label: 'Select'
  });

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<DataType> = {
    selectedRowKeys,
    onChange: onSelectChange,
    preserveSelectedRowKeys: true
  };

  // Handle seach table search

  const getDate = (startDate: string, endDate: string) => {
    setFilterDateFrom(startDate);
    setFilterDateTo(endDate);
    setCurrentPage(1);
  };

  const getText = (text: string) => {
    setValueSearch(text);
  };
  const SearchName = () => {};
  const getSelectFilter: MenuProps['onClick'] = (e) => {
    setSearchBy(e.key);
    setLabelFilter({ key: e.key, label: e.domEvent.target.innerText });
  };
  const getSelectFilterBy: MenuProps['onClick'] = (e) => {
    setLabelReturn({ key: e.key, label: e.domEvent.target.innerText });
    setFilterBy(e.key);
    setCurrentPage(1);
  };

  const menuFilterBy = [
    {
      id: 1,
      title: 'Select',
      list: (
        <Menu
          onClick={getSelectFilterBy}
          items={[
            { label: 'Retransfer', key: 'Return' },
            {
              label: 'Disposal',
              key: 'Disposal'
            }
          ]}
        />
      )
    }
  ];

  const menuFilter = [
    {
      id: 1,
      title: 'Select',
      list: (
        <Menu
          onClick={getSelectFilter}
          items={[
            { label: 'Seller  Name', key: 'name' },
            {
              label: 'Product Name',
              key: 'productName'
            },
            {
              label: 'SKU',
              key: 'sku'
            }
          ]}
        />
      )
    }
  ];

  const idMap = selectedRowKeys.map((item: React.Key) => item);

  const arrId = {
    ids: idMap
  };
  const handleDownload = async () => {
    if (selectedRowKeys.length === 0) {
      const resp = await returnDisposalService.exportExcel({
        currentPage,
        sort,
        filterDateFrom,
        filterDateTo,
        filterBy,
        searchBy,
        valueSearch
      });
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Return_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([resp]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await returnDisposalService.postDownloadExcelId(arrId);
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Return_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  return (
    <Spin spinning={loading} className="loading-forgot">
      <>
        <SearchTable
          labelSearchType={labelReturn}
          labelSearchFilter={labelFilter}
          getDate={getDate}
          searchText={getText}
          searchType={menuFilterBy}
          searchFilter={menuFilter}
          isReturn={true}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '15px 17px',
            background: 'white',
            alignItems: 'center'
          }}
        >
          <div>
            <span style={{ marginLeft: 8, marginRight: 8 }}>
              Total {data.count}
            </span>
            <Divider type="vertical" />
            <span style={{ marginLeft: 8 }}>
              Select {selectedRowKeys.length}
            </span>
          </div>

          <div>
            <Button className="downExcel" onClick={handleDownload}>
              Download Excel
            </Button>
          </div>
        </div>

        <Table
          className="warehouse-table"
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data?.rowData}
          pagination={{
            pageSize: 10,
            total: data.count,
            current: currentPage,
            onChange: (currentPage) => {
              setCurrentPage(currentPage);
              handleReturnDisposalListWithPagination(
                currentPage,
                sort,
                filterDateFrom,
                filterDateTo,
                filterBy,
                searchBy,
                valueSearch
              );
            }
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                history.push({
                  pathname: `/admin/return/${record.key}?return_type=${record.returnType}`,
                  state: {
                    state: `${record.returnType}`,
                    status: `${record.status}`
                  }
                });
              }
            };
          }}
        />
      </>
    </Spin>
  );
}

export default TableReturn;
